<template>
  <div :class="'site-tree-item depth-' + `${depth}`">
    <div class="site-row" :class="{ 'has-children': hasChildren(site), 'is-expanded': isExpanded(site.id) }">
      <button v-if="hasChildren(site)" class="expand-toggle" @click.stop="toggleExpand(site.id)">
        <span class="material-symbols-outlined" :class="{ 'rotated': isExpanded(site.id) }">chevron_right</span>
      </button>
      <div v-else class="expand-spacer"></div>

      <div class="site-info" @click.stop="$router.push({name: 'Dashboard',params: { site_id: site.id },})">
        <div class="site-logo">
          <img v-if="site.logo_url" :src="site.logo_url" :alt="site.name" class="logo-image"/>
          <div v-else class="logo-placeholder">
            <span class="material-symbols-outlined">{{ hasChildren(site) ? 'folder' : 'location_on' }}</span>
          </div>
        </div>
        <div class="site-details">
          <h4 class="site-name">{{ site.name }}</h4>
          <span v-if="hasChildren(site)" class="site-children-count">
          {{ getChildrenCount(site) }} sous-site{{ getChildrenCount(site) > 1 ? 's' : '' }}
        </span>
        </div>
      </div>

      <div class="site-actions">
        <button class="btn btn-action btn-view" @click.stop="handleSelectSite(site.id)" title="Visualiser">
          <span class="material-symbols-outlined">monitoring</span>
          <span class="action-label">Visualiser</span>
        </button>
        <button class="btn btn-action btn-info" @click.stop="showItem(site)" title="Détails">
          <span class="material-symbols-outlined">info</span>
        </button>
        <!-- <button class="btn btn-action btn-info" @click.stop="$router.push({name: 'Dashboard',params: { site_id: site.id },})" title="Dashboard">
          <span class="material-symbols-outlined">dashboard</span>
        </button> -->
        <button class="btn btn-action btn-info" @click.stop="editItem(site)" title="Paramètres">
          <span class="material-symbols-outlined">settings</span>
        </button>
      </div>
    </div>

    <div v-if="hasChildren(site) && isExpanded(site.id)" class="site-children">
      <UserSitesChild v-for="child in getChildrenSites(site)" :key="child.id" :depth="depth+1" :site="child" :handleSelectSite="handleSelectSite" :showItem="showItem" :editItem="editItem" :hasChildren="hasChildren" :getChildrenCount="getChildrenCount" :isExpanded="isExpanded" :toggleExpand="toggleExpand" :getChildrenSites="getChildrenSites"/>
    </div>
  </div>

</template>

<script>

export default {
  name: 'UserSitesChild',
  props: {
    depth: {
      type: Number,
      required: true
    },
    site: {
      type: Object,
      required: true
    },
    handleSelectSite: {
      type: Function,
      required: true
    },
    showItem: {
      type: Function,
      required: true
    },
    editItem: {
      type: Function,
      required: true
    },
    hasChildren: {
      type: Function,
      required: true
    },
    getChildrenCount: {
      type: Function,
      required: true
    },
    isExpanded: {
      type: Function,
      required: true
    },
    toggleExpand: {
      type: Function,
      required: true
    },
    getChildrenSites: {
      type: Function,
      required: true
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  updated() {},
  watch: {},
  methods: {}
};
</script>

<style scoped>
/* ============================================
   CSS Variables - Light Green Theme
   ============================================ */
.sites-container {
  /* Primary greens - refined palette */
  --color-primary: #2d5a3d;
  --color-primary-light: #3d7a52;
  --color-primary-lighter: #5a9e6f;
  --color-primary-dark: #1e3d29;
  --color-primary-bg: #e8f0eb;

  /* Accent */
  --color-accent: #5a9e6f;
  --color-accent-light: #a8d4b8;

  /* Surfaces - clean whites and light grays */
  --color-surface: #ffffff;
  --color-surface-primary: #e8f0eb;
  --color-surface-secondary: #fafbfa;
  --color-surface-hover: #f0f4f1;
  --color-background: #f5f7f6;

  /* Borders */
  --color-border: #e2e8e4;
  --color-border-light: #f0f4f1;

  /* Text */
  --color-text-primary: #1a2e1f;
  --color-text-secondary: #5a6b5e;
  --color-text-muted: #8a998e;

  /* Status colors */
  --color-danger: #dc2626;
  --color-danger-bg: #fef2f2;
  --color-warning: #d97706;
  --color-warning-bg: #fffbeb;
  --color-success: #059669;
  --color-success-bg: #ecfdf5;

  /* Shadows */
  --shadow-xs: 0 1px 2px rgba(45, 90, 61, 0.04);
  --shadow-sm: 0 1px 2px rgba(45, 90, 61, 0.05);
  --shadow-md: 0 4px 12px rgba(45, 90, 61, 0.08);
  --shadow-lg: 0 12px 40px rgba(45, 90, 61, 0.12);

  /* Radii */
  --radius-sm: 6px;
  --radius-md: 10px;
  --radius-lg: 16px;
  --radius-xl: 20px;

  /* Transitions */
  --transition-fast: 150ms ease;
  --transition-normal: 200ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-smooth: 300ms cubic-bezier(0.4, 0, 0.2, 1);

  /* Graph/Visualization specific */
  --color-graph-bg: #ffffff;

  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background: var(--color-background);
  color: var(--color-text-primary);
  padding: 24px;
  height: 100%;
  min-height: 0;
}

.sites-content {
  max-width: 1200px;
  margin: 0 auto;
}

/* ============================================
   Header Section
   ============================================ */
.sites-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  margin-bottom: 16px;
  padding: 20px 24px;
  background: var(--color-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--color-border-light);
}

.header-left {
  flex: 1;
  min-width: 0;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Breadcrumb - Separate from header */
.breadcrumb {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 20px;
  padding: 12px 16px;
  background: var(--color-surface);
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border-light);
}

.breadcrumb-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  font-size: 14px;
  font-weight: 500;
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.breadcrumb-item:hover:not(.active) {
  background: var(--color-primary-bg);
  color: var(--color-primary);
}

.breadcrumb-item.active {
  background: var(--color-primary-bg);
  border-color: var(--color-primary-lighter);
  color: var(--color-primary);
}

.breadcrumb-item .material-symbols-outlined {
  font-size: 18px;
}

.breadcrumb-divider {
  color: var(--color-text-muted);
  display: flex;
  align-items: center;
}

.breadcrumb-divider .material-symbols-outlined {
  font-size: 18px;
}

/* Search */
.search-container {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 14px;
  color: var(--color-text-muted);
  font-size: 20px;
  pointer-events: none;
}

.search-input {
  width: 280px;
  padding: 12px 40px 12px 44px;
  background: var(--color-surface-secondary);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  font-size: 14px;
  color: var(--color-text-primary);
  transition: all var(--transition-fast);
}

.search-input::placeholder {
  color: var(--color-text-muted);
}

.search-input:focus {
  outline: none;
  background: var(--color-surface);
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(90, 158, 58, 0.15);
}

.search-clear {
  position: absolute;
  right: 10px;
  background: var(--color-surface-hover);
  border: none;
  padding: 4px;
  cursor: pointer;
  color: var(--color-text-muted);
  border-radius: 50%;
  display: flex;
  transition: all var(--transition-fast);
}

.search-clear:hover {
  background: var(--color-primary-bg);
  color: var(--color-primary);
}

.search-clear .material-symbols-outlined {
  font-size: 16px;
}

/* ============================================
   Buttons
   ============================================ */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 18px;
  border: none;
  border-radius: var(--radius-md);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-fast);
  white-space: nowrap;
}

.btn .material-symbols-outlined {
  font-size: 18px;
}

.btn-primary {
  background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-light) 100%);
  color: white;
  box-shadow: var(--shadow-sm);
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
  background: linear-gradient(135deg, var(--color-primary-dark) 0%, var(--color-primary) 100%);
}

.btn-ghost {
  background: transparent;
  color: var(--color-text-secondary);
  border: 1px solid var(--color-border);
}

.btn-ghost:hover {
  background: var(--color-surface-hover);
  border-color: var(--color-primary-lighter);
  color: var(--color-text-primary);
}

.btn-danger {
  background: var(--color-danger);
  color: white;
}

.btn-danger:hover {
  background: #C62828;
}

.btn-action {
  padding: 8px 12px;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  font-size: 13px;
}

.btn-action:hover {
  background: var(--color-primary-bg);
  border-color: var(--color-primary-lighter);
  color: var(--color-primary);
}

.btn-view {
  background: var(--color-primary-bg);
  border-color: var(--color-primary-lighter);
  color: var(--color-primary);
}

.btn-view:hover {
  background: var(--color-primary);
  border-color: var(--color-primary);
  color: white;
}

.btn-info {
  padding: 8px;
}

.action-label {
  display: none;
}

@media (min-width: 768px) {
  .action-label {
    display: inline;
  }
}

/* Same rule, but reacting to the tree panel's actual rendered width
   (see UserAdminSitesT.vue, which establishes the container) instead
   of the viewport — needed when this component is squeezed into a
   fraction of the screen (Home.vue's split view), which is common on
   laptops running above 100% OS display scaling. */
@container (max-width: 767px) {
  .action-label {
    display: none;
  }
}

/* ============================================
   Clients Grid
   ============================================ */
.clients-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.client-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: var(--color-surface);
  border: 1px solid var(--color-border-light);
  border-radius: var(--radius-lg);
  cursor: pointer;
  transition: all var(--transition-normal);
}

.client-card:hover {
  border-color: var(--color-primary);
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}

.client-logo {
  width: 56px;
  height: 56px;
  border-radius: var(--radius-md);
  overflow: hidden;
  background: var(--color-surface-secondary);
  border: 2px solid var(--color-border);
  flex-shrink: 0;
  transition: all var(--transition-fast);
}

.client-card:hover .client-logo {
  border-color: var(--color-primary);
}

.logo-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.logo-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--color-primary-light) 0%, var(--color-primary) 100%);
}

.logo-placeholder .material-symbols-outlined {
  font-size: 26px;
  color: white;
}

.client-info {
  flex: 1;
  min-width: 0;
}

.client-name {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin: 0 0 4px;
}

.client-sites-count {
  font-size: 13px;
  color: var(--color-text-muted);
}

.client-arrow {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-surface-secondary);
  border-radius: 50%;
  color: var(--color-text-muted);
  transition: all var(--transition-fast);
}

.client-card:hover .client-arrow {
  background: var(--color-primary);
  color: white;
  transform: translateX(4px);
}

/* ============================================
   Sites Hierarchy (Tree View)
   ============================================ */
.sites-hierarchy {
  background: var(--color-surface);
  border-radius: var(--radius-lg);
  border: 1px solid var(--color-border-light);
  overflow: hidden;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 20px;
  background: var(--color-surface-secondary);
  border: none;
  border-bottom: 1px solid var(--color-border-light);
  font-size: 14px;
  font-weight: 500;
  color: var(--color-text-secondary);
  cursor: pointer;
  width: 100%;
  transition: all var(--transition-fast);
}

.back-button:hover {
  background: var(--color-primary-bg);
  color: var(--color-primary);
}

.back-button .material-symbols-outlined {
  font-size: 18px;
}

.sites-tree {
  padding: 8px 0;
}

/* Site Tree Item */
.site-tree-item {
  border-bottom: 1px solid var(--color-border-light);
}

.site-tree-item:last-child {
  border-bottom: none;
}

.site-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  transition: background var(--transition-fast);
}

.site-row:hover {
  background: var(--color-surface-hover);
}

/* Depth indentation with visual hierarchy */
.depth-0 > .site-row { padding-left: 16px; }
.depth-1 > .site-row { padding-left: 40px; background: var(--color-surface-primary); }
.depth-2 > .site-row { padding-left: 64px; }
.depth-3 > .site-row { padding-left: 88px; background: var(--color-surface-primary); }
.depth-4 > .site-row { padding-left: 112px; }

/* Expand toggle */
.expand-toggle {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
  color: var(--color-text-muted);
  cursor: pointer;
  transition: all var(--transition-fast);
  flex-shrink: 0;
}

.expand-toggle:hover {
  background: var(--color-primary-bg);
  color: var(--color-primary);
}

.expand-toggle .material-symbols-outlined {
  font-size: 20px;
  transition: transform var(--transition-fast);
}

.expand-toggle .material-symbols-outlined.rotated {
  transform: rotate(90deg);
}

.expand-spacer {
  width: 28px;
  flex-shrink: 0;
}

/* Site info */
.site-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: var(--radius-sm);
  transition: background var(--transition-fast);
}

.site-info:hover {
  background: var(--color-primary-bg);
}

.site-logo {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-sm);
  overflow: hidden;
  background: var(--color-surface-secondary);
  border: 1px solid var(--color-border);
  flex-shrink: 0;
}

.site-logo .logo-placeholder {
  background: linear-gradient(135deg, var(--color-primary-lighter) 0%, var(--color-primary-light) 100%);
}

.site-logo .logo-placeholder .material-symbols-outlined {
  font-size: 20px;
}

.site-details {
  flex: 1;
  min-width: 0;
}

.site-name {
  font-size: 14px;
  font-weight: 500;
  color: var(--color-text-primary);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.site-children-count {
  font-size: 12px;
  color: var(--color-text-muted);
}

/* Site actions */
.site-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

/* Children container */
.site-children {
  overflow: hidden;
}

/* Accordion animation */
.accordion-enter-active,
.accordion-leave-active {
  transition: all var(--transition-smooth);
}

.accordion-enter,
.accordion-leave-to {
  opacity: 0;
  max-height: 0;
}

.accordion-enter-to,
.accordion-leave {
  opacity: 1;
  max-height: 2000px;
}

/* ============================================
   Empty State
   ============================================ */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.empty-icon {
  font-size: 56px;
  color: var(--color-text-muted);
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-state h3 {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin: 0 0 8px;
}

.empty-state p {
  font-size: 14px;
  color: var(--color-text-secondary);
  margin: 0;
}

/* ============================================
   Loading State
   ============================================ */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 24px;
}

.loader {
  display: flex;
  gap: 8px;
}

.loader-dot {
  width: 12px;
  height: 12px;
  background: var(--color-primary);
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out both;
}

.loader-dot:nth-child(1) {
  animation-delay: -0.32s;
}

.loader-dot:nth-child(2) {
  animation-delay: -0.16s;
  background: var(--color-primary-light);
}

.loader-dot:nth-child(3) {
  background: var(--color-accent);
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

.loading-state p {
  font-size: 14px;
  color: var(--color-text-secondary);
}

/* ============================================
   Modal
   ============================================ */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(44, 62, 40, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}

.modal-card {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: 32px;
  max-width: 400px;
  width: 100%;
  text-align: center;
  box-shadow: var(--shadow-lg);
}

.modal-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-danger-bg);
  border-radius: 50%;
}

.modal-icon .material-symbols-outlined {
  font-size: 28px;
  color: var(--color-danger);
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin: 0 0 8px;
}

.modal-site-name {
  font-size: 15px;
  font-weight: 500;
  color: var(--color-primary);
  margin: 0 0 8px;
}

.modal-warning {
  font-size: 13px;
  color: var(--color-text-muted);
  margin: 0 0 24px;
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.modal-actions .btn {
  min-width: 120px;
}

/* ============================================
   Transitions
   ============================================ */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 200ms ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active .modal-card,
.modal-fade-leave-active .modal-card {
  transition: transform 200ms ease;
}

.modal-fade-enter .modal-card,
.modal-fade-leave-to .modal-card {
  transform: scale(0.95);
}

/* ============================================
   Material Symbols
   ============================================ */
.material-symbols-outlined {
  font-family: 'Material Symbols Outlined', sans-serif;
  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
  font-size: 20px;
  line-height: 1;
}

/* ============================================
   Graph/Visualization Background Helper
   ============================================ */
.graph-container,
.visualization-container,
.chart-container {
  background: var(--color-graph-bg) !important;
  border-radius: var(--radius-md);
  padding: 16px;
}

/* ============================================
   Responsive
   ============================================ */
@media (max-width: 768px) {
  .sites-container {
    padding: 16px;
  }

  .sites-header {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    padding: 16px;
  }

  .header-right {
    flex-direction: column;
  }

  .search-input {
    width: 100%;
  }

  .btn-primary {
    width: 100%;
  }

  .btn-text {
    display: none;
  }

  .breadcrumb-label {
    display: none;
  }

  .clients-grid {
    grid-template-columns: 1fr;
  }

  .site-row {
    padding: 10px 12px;
  }

  .depth-0 > .site-row { padding-left: 12px; }
  .depth-1 > .site-row { padding-left: 28px; }
  .depth-2 > .site-row { padding-left: 44px; }
  .depth-3 > .site-row { padding-left: 60px; }
  .depth-4 > .site-row { padding-left: 76px; }

  .site-actions .btn-view .action-label {
    display: none;
  }
}

/* Same tightening, keyed off the tree panel's own rendered width
   (see the matching @container block in UserAdminSitesT.vue). */
@container (max-width: 768px) {
  .site-row {
    padding: 10px 12px;
  }

  .depth-0 > .site-row { padding-left: 12px; }
  .depth-1 > .site-row { padding-left: 28px; }
  .depth-2 > .site-row { padding-left: 44px; }
  .depth-3 > .site-row { padding-left: 60px; }
  .depth-4 > .site-row { padding-left: 76px; }

  .site-actions .btn-view .action-label {
    display: none;
  }
}
</style>